import { IDmLoaiChungChiChungNhan } from "../../model/response/category/IDmLoaiChungChiChungNhan";
import { apiClient } from "../apiClient";
export const LOAI_CHUNG_CHI_CHUNG_NHAN_ENDPOINT ="loai-chung-chi-chung-nhan";
export const loaiChungChiChungNhanApi = {
  SelectAll: () => apiClient.get(`${LOAI_CHUNG_CHI_CHUNG_NHAN_ENDPOINT}`),
  Insert: (data: IDmLoaiChungChiChungNhan) => apiClient.post(`${LOAI_CHUNG_CHI_CHUNG_NHAN_ENDPOINT}`, data),
  Update: ( id: number, data: IDmLoaiChungChiChungNhan) => apiClient.put(`${LOAI_CHUNG_CHI_CHUNG_NHAN_ENDPOINT}/${id}`, data),
  Delete: (id: number) => apiClient.delete(`${LOAI_CHUNG_CHI_CHUNG_NHAN_ENDPOINT}/${id}`),
};
